import {ActionsType} from "../actions/user";
import {NsiItem} from "../../api/types";

let initialState = {
    id          : null as number | null,//нач. значение as type | null
    username    : null as string | null,
    email       : null as string | null,
    roles       : [] as string[],
    isAuth      : false as boolean,
    clientTypes : [] as NsiItem[],
    docTypes    : [] as NsiItem[],
    captchaUrl  : null as string | null
};
export type InitialStateType = typeof initialState;

const user = (state = initialState, action: ActionsType): InitialStateType => {
    switch (action.type) {
        case 'MB/USER/SET_USER_DATA':
        case 'MB/USER/GET_CAPTCHA_URL_SUCCESS':
            return {
                ...state,
                ...action.payload,
                isAuth: true
            }
        case 'MB/USER/CLEAR_USER_DATA':
            return {
                ...state,
                id: null,
                username: null,
                email: null,
                roles: [],
                isAuth: false
            }

        case 'MB/USER/SET_USER_TYPES':
            return {
                ...state,
                clientTypes: action.values
            }
        case 'MB/USER/CLEAR_USER_TYPES':
            return {
                ...state,
                clientTypes: []
            }

        case 'MB/USER/SET_DOC_TYPES':
            return {
                ...state,
                docTypes: action.values
            }
        case 'MB/USER/CLEAR_DOC_TYPES':
            return {
                ...state,
                docTypes: []
            }
        default:
            return state;
    }
}

export default user;